import carShowComponent from "./car/show.component.vue";
import carUpdateComponent from "./car/update.component.vue";
import cardShowComponent from "./card/show.component.vue";
import cardUpdateComponent from "./card/update.component.vue";
import profileShowComponent from "./profile/show.component.vue";
import profileUpdateComponent from "./profile/update.component.vue";
import inquiryIndexComponent from "./inquiry/index.component.vue";

export default {
    components: {
        carShowComponent,
        carUpdateComponent,
        cardShowComponent,
        cardUpdateComponent,
        profileShowComponent,
        profileUpdateComponent,
        inquiryIndexComponent
    },
    data() {
        return {
            updateFlg: false,
            carUpdateFlg: false,
            cardUpdateFlg: false,
            profileUpdateFlg: false,
        }
    },
    async mounted() {
    },
    methods: {
        updatePageClose() {
            this.updateFlg = false;
            this.carUpdateFlg = false;
            this.cardUpdateFlg = false;
            this.profileUpdateFlg = false;
        },
        updatePageOpen(flg) {
            this.updateFlg = true;
            if (flg == 1) {
                this.cardUpdateFlg = true;
            } else if (flg ==2) {
                this.carUpdateFlg = true;
            } else if (flg == 3) {
                this.profileUpdateFlg = true;
            }
        },
    }
}